import { Component, OnInit } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '.../../environments/environment'
import { Broadcaster } from '.../../environments/broadcaster'
import { utils, write, WorkBook } from 'xlsx'
import { saveAs } from 'file-saver'
import { AuthService } from '../../../_services/index'
import { LoaderService } from 'app/_services/loader.service'
import Swal from 'sweetalert2'
import * as momentDate from 'moment'
declare var $: any

@Component({
  selector: 'app-entity',
  templateUrl: './entity.component.html',
  styleUrls: ['./entity.component.css'],
})
export class EntityComponent implements OnInit {
  showLoader: boolean
  public entityData: any
  public prjId: any
  public userid: any
  selectedRow: Number
  selectedVehEntityRow: Number
  selectedEmpAssignRow: Number
  public entityAssignTypeData: any
  public ddlEntityAssignType: any
  public txtEntityName: any
  public search: any
  public searchModal: any
  public entyAssignMsgSuccess = false
  public entyAssignMsgWarning = false
  public entyAssignMsgError = false
  public entityRecordNotFound = false
  public entityAssignError = false
  public entityEmpAssignSuccess = false
  public entityEmpAssignWarning = false
  public entityEmpAssignError = false
  public entityId: any
  public vehicleAssignData: any
  public vehId: any
  public status: any
  public isAssign: any
  public isAssignedEmpStstus: any
  public entityAssignJsonData: any
  public isEmpAssignbtn = false
  public staffAssignmentData: any
  public empId: any
  public oemId: any
  public roleId: any
  public ddlEntityModal: any
  public khatttaZoneSelectedModel: any
  public khatttaWardSelectedModel: any
  public entityTypData: any
  public ddlEntitysModal: any
  public entityParantData: any
  public entityCodeModal: any
  public entityNameModal: any
  public ddlParantModal: any
  public txtAreaKmlModal: any
  public EntityStatusData: any
  public currentDate: any
  public entityIsActiveModel: any
  public entitySaveSuccessMsg = false
  public entitySaveWarningMsg = false
  public entityNameSaveSuccessMsg = false
  public entityNameSaveWarningMsg = false
  public isSavebtn = false
  public entityNameMsg = false
  public entityOrgnizedMsg = false
  public entityCodeMsg = false
  public entityNameAlertMsg = false
  public entityPrntNameMsg = false
  public imagePath: any
  public ddlEntityCatModal: any
  public ddlEntityTypeModal: any
  public entityEntCodeDiv = false
  public entityTypId: any
  public entyVehAssignReNotFound = false
  public entyStaffAssignReNotFound = false
  titleData: any
  successMsg: any
  changeStatus: any
  empassignMsg: any
  assignStatus: any
  staffAssignstatus: any
  vehicleAssignedList: any
  vehAssignNotFound = false
  currntEntityId: any
  staffAssignedList: any
  staffAssignNotFound = false
  empAssignCount: any
  vehAssinedCount: any
  empAssignListCount: any
  vehassignListCount: any
  vehSearchModal: any
  empSearchModal: any
  vehAssignSearchModal: any
  empAssignSearchModal: any
  entityTypeData: any
  zoneCount: any
  wardCount: any
  beatCount: any
  routeCount: any
  KMLModal: string
  allZonesData: any
  allWardsData: any
  entityNewName: any
  isAllZoneWardDataUpdated = false
  entityUpdateId: any
  entityUpdateValue: any
  kmlPlacemark: any
  uploadingKmltype: any
  entityKmlRawData: any
  finishEntityEntryDetails: any
  placeMarksLength: any
  kmlRawFile: any
  constructor(
    private http: HttpClient,
    private broadcaster: Broadcaster,
    private auth: AuthService,
    private loaderService: LoaderService,
  ) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val
    })
    // this.entityTypeData =
    //   [{
    //     "ID": 1,
    //     "VALUE": "All",
    //   },
    //   {
    //     "ID": 7,
    //     "VALUE": "Zone",
    //   },
    //   {
    //     "ID": 8,
    //     "VALUE": "Ward",
    //   },
    //   {
    //     "ID": 9,
    //     "VALUE": "Beat",
    //   },
    //   {
    //     "ID": 10,
    //     "VALUE": "Route",
    //   }]

    this.uploadingKmltype = null
    this.entityKmlRawData = null
    this.finishEntityEntryDetails = []
    this.currentDate = new Date()
  }
  public BindEntityStatus() {
    this.EntityStatusData = [
      {
        ID: 1,
        VALUE: 'ACTIVE',
      },
      {
        ID: 2,
        VALUE: 'INACTIVE',
      },
    ]
  }

  //To get the Entity Type Id on ddl select
  onChangeToSelectEntityType(OEMTYPEID) {
    // this.getEntityDetails(OEMTYPEID);
    this.loaderService.display(true)
    // this.http.get(environment.apiUrl + 'admin/getEntityMasterDetailsByProject?PRJID=' + this.prjId + '&OEMID=' + OEMID).subscribe((data) => {
    this.http
      .get(
        environment.apiUrl +
          'admin/getEntityTypDetailsByProject?PRJID=' +
          this.prjId +
          '&OEMTYPID=' +
          OEMTYPEID,
      )
      .subscribe((data) => {
        this.entityTypeData = data
        if (this.entityTypeData.length > 0) {
          this.ddlEntityModal = this.entityTypeData[0].ID
          this.entityRecordNotFound = false
          this.loaderService.display(false)
        } else {
          this.entityRecordNotFound = true
          this.loaderService.display(false)
        }
        this.getEntityDetails(this.ddlEntityModal)
      })
  }

  selectEntityMstDetailsRowData(entityData, index) {
    this.entityId = entityData.ID
    this.getVehAssignmentbyEntityId() //bind Entity assign Table
    this.getStaffAssignmentbyEntityId() //bind Staff assign Table
    this.selectedRow = index
    this.txtEntityName = entityData.ENTITYNAME
  }
  selectEntityAssignRowData(vehicleAssignData, index) {
    this.vehId = vehicleAssignData.vehID
    this.selectedVehEntityRow = index
    this.isAssign = vehicleAssignData.isAssigned
    this.status = vehicleAssignData.isactive
  }

  //This Method is used to get the Entity Master Data
  getEntityDetails(OEMID) {
    this.http
      .get(
        environment.apiUrl +
          'admin/getEntityMasterDetailsByProject?PRJID=' +
          this.prjId +
          '&OEMID=' +
          OEMID,
      )
      .subscribe((data) => {
        this.entityData = data
        if (this.entityData.length > 0) {
          this.entityRecordNotFound = false
          for (var i = 0; i < this.entityData.length; i++) {
            // if (this.entityData[i].entitytype == "ZONE") {
            //   this.zoneCount = this.zoneCount + 1
            // } if (this.entityData[i].entitytype == "WARD") {
            //   this.wardCount = this.wardCount + 1
            // } if (this.entityData[i].entitytype == "BEAT") {
            //   this.beatCount = this.beatCount + 1
            // } if (this.entityData[i].entitytype == "ROUTE") {
            //   this.routeCount = this.routeCount + 1
            // }
            this.loaderService.display(false)
          }
        } else {
          this.entityRecordNotFound = true
          this.loaderService.display(false)
        }
      })
  }

  getZonesAndWards() {
    this.allZonesData = this.getEntityDetails(7)
    this.allWardsData = this.getEntityDetails(8)
    this.isAllZoneWardDataUpdated = true
  }

  getEntitysummary(oemid) {
    // this.zoneCount = 0;
    // this.wardCount = 0
    // this.beatCount = 0;
    // this.routeCount = 0;
  }

  //This method is used to assignment the entity master Details
  entityAssignMaster() {
    $('#entityMstrAssignModel').modal('show')
  }

  //This method is used to get the Entity Type as per Project ID/Name
  getEntityTypeByProject() {
    this.http
      .get(
        environment.apiUrl +
          'admin/getEntityTypeMasterByProject?PRJID=' +
          this.prjId,
      )
      .subscribe((data) => {
        this.entityAssignTypeData = data
        console.log(data)
        this.ddlEntityAssignType = this.entityAssignTypeData[0].ID
        let oemId = this.entityAssignTypeData[0].ID
        if (oemId != undefined) {
          this.getEntityDetails(oemId)
          this.onChangeToSelectEntityType(oemId)
        } else {
          alert('Entity Id not available.')
        }
      })
  }
  //This Method is use to Download the Vehicles Report into Excel File
  importEntityExcelReport(entityData) {
    const ws_name = 'EntityReport'
    const wb: WorkBook = { SheetNames: [], Sheets: {} }
    const ws: any = utils.json_to_sheet(entityData)
    wb.SheetNames.push(ws_name)
    wb.Sheets[ws_name] = ws
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' })
    saveAs(
      new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      'exportedEntityReport.xlsx',
    )
  }
  s2ab(s) {
    const buf = new ArrayBuffer(s.length)
    const view = new Uint8Array(buf)
    for (let i = 0; i !== s.length; ++i) {
      view[i] = s.charCodeAt(i) & 0xff
    }
    return buf
  }
  //Open Assign modal popup windows
  entityAssignment(data) {
    console.log('sele assignement', data)
    this.currntEntityId = data.ID
    this.getAssignedVehicleList(this.currntEntityId)
    this.getAssignedStaffList(this.currntEntityId)
    $('#entityMstrAssignModel').modal('show')
  }

  /*
   * get Vehicle Assignment List
   */
  getVehAssignmentbyEntityId() {
    this.http
      .get(
        environment.apiUrl +
          'admin/getVehAssignmentbyEntityAndPrjID?PRJID=' +
          this.prjId +
          '&ENTITYID=' +
          this.entityId,
      )
      .subscribe((data) => {
        this.vehicleAssignData = data
        if (this.vehicleAssignData == 0) {
          this.vehassignListCount = 0
          this.entityRecordNotFound = true
        } else {
          this.vehassignListCount = this.vehicleAssignData.length
          this.entityRecordNotFound = false
        }
      })
  }

  //This Method is used to Add New Entity Modal Papup
  addNewEntityDetails() {
    this.isSavebtn = true
    $('#addNewEntityModal').modal('show')
  }

  /*
   * get Staff assigne Data
   */
  getStaffAssignmentbyEntityId() {
    this.http
      .get(
        environment.apiUrl +
          'admin/getStaffAssignmentbyEntityAndPrjID?PRJID=' +
          this.prjId +
          '&ENTITYID=' +
          this.entityId,
      )
      .subscribe((data) => {
        this.staffAssignmentData = data
        if (this.staffAssignmentData == 0) {
          this.entityRecordNotFound = true
          this.empAssignListCount = 0
        } else {
          this.empAssignListCount = this.staffAssignmentData.length
          this.entityRecordNotFound = false
        }
      })
  }

  viewPolygon() {
    $('#viewPolygonModal').modal('show')
  }

  //####################### Add New Entity Details##################//

  onChangeToSelectEntityCatType() {
    if (
      this.ddlEntityCatModal == null ||
      this.ddlEntityCatModal == undefined ||
      this.ddlEntityCatModal == ''
    ) {
      this.isSavebtn = true
      this.entityNameMsg = true
      return
    }
    this.entityNameMsg = false
    this.http
      .get(
        environment.apiUrl +
          'admin/getEntityTypDetailsByProject?PRJID=' +
          this.prjId +
          '&OEMTYPID=' +
          this.ddlEntityCatModal,
      )
      .subscribe((data) => {
        this.entityTypData = data
      })
  }

  //To select Entity Type Name
  onChangeToSelectParntId(data) {
    this.entityTypId = data.ID
    if (
      (this.ddlEntityTypeModal == null ||
        this.ddlEntityTypeModal == undefined ||
        this.ddlEntityTypeModal == '') &&
      this.entityTypId == null
    ) {
      this.isSavebtn = true
      this.entityOrgnizedMsg = true
      this.ddlEntityCatModal = null
      return
    } else {
      this.isSavebtn = false
      this.entityOrgnizedMsg = false
      this.http
        .get(
          environment.apiUrl +
            'admin/getEntityDetailsbyOEMID?PRJID=' +
            this.prjId +
            '&PRNTID=' +
            this.ddlEntityTypeModal,
        )
        .subscribe((data) => {
          this.entityParantData = data
          if (this.entityParantData.length > 0) {
            this.oemId = this.entityParantData[0].OEMID
          }
        })
    }
  }

  /*
   * this method is used to save the Entity Details into the entitymst table
   */
  saveEntityDetails() {
    var entityStatus
    this.isSavebtn = true
    this.currentDate = new Date()
    if (
      this.ddlEntityCatModal == null ||
      this.ddlEntityCatModal == undefined ||
      this.ddlEntityCatModal == ''
    ) {
      this.isSavebtn = true
      this.entityNameMsg = true
      return
    }
    if (
      (this.entityTypId == null ||
        this.entityTypId == undefined ||
        this.entityTypId == '') &&
      this.entityTypData[0].ID == null
    ) {
      this.isSavebtn = true
      this.entityOrgnizedMsg = true
      return
    }
    if (
      this.entityCodeModal == null ||
      this.entityCodeModal == undefined ||
      this.entityCodeModal == ''
    ) {
      this.isSavebtn = true
      this.entityCodeMsg = true
      return
    }
    if (
      this.entityNameModal == null ||
      this.entityNameModal == undefined ||
      this.entityNameModal == ''
    ) {
      this.isSavebtn = true
      this.entityNameAlertMsg = true
      return
    }
    if (this.entityIsActiveModel == 1) {
      entityStatus = 1
    } else {
      entityStatus = 0
    }
    this.txtAreaKmlModal = this.txtAreaKmlModal ? this.txtAreaKmlModal : null
    var entityMstrJsonData = {
      entityData: this.finishEntityEntryDetails,
    }

    console.log('entityMstrJsonData', entityMstrJsonData)

    // kml format : POLYGON ((77.3201925548893 28.4161629044559,77.32097111663489 28.41621260384356,77.32106234128109 28.41669133568179,77.32010236062804 28.41691808292313,77.3201925548893 28.4161629044559))

    // kmlGeography:  Geography::STGeomFromText('LINESTRING(77.0497925 28.480974, 77.0503825 28.4798046, 77.05060779999999 28.4800121, 77.0510799 28.4800404, 77.05133739999999 28.4803327)', 4269)

    this.http
      .post(
        environment.apiUrl + 'admin/saveEntityMasterDetails',
        entityMstrJsonData,
      )
      .subscribe(
        (data) => {
          var entitydata = data
          this.entitySaveSuccessMsg = true
          setTimeout(() => {
            this.entitySaveSuccessMsg = false
            this.clearEntityData()
          }, 3000)
        },
        (error) => {
          this.clearEntityData()
          this.entitySaveWarningMsg = true
        },
      )
  }

  kmlType(e) {
    console.log(e.target.value)

    this.uploadingKmltype = e.target.value

    if (this.entityKmlRawData != null) {
      this.readDataForm(this.entityKmlRawData)
    }
  }

  fetchkmlData(e) {
    this.entityKmlRawData = null
    this.finishEntityEntryDetails = []
    let fileReader = new FileReader()
    fileReader.onload = (e) => {
      this.entityKmlRawData = fileReader.result
      this.readDataForm(this.entityKmlRawData)
    }
    fileReader.readAsText(e.target.files[0])
  }

  readDataForm(kmlData) {
    var parser, xmlDoc
    var text = kmlData

    parser = new DOMParser()
    xmlDoc = parser.parseFromString(text, 'text/xml')

    this.placeMarksLength = xmlDoc.getElementsByTagName('Placemark').length

    let kmlPrimeName = xmlDoc.getElementsByTagName('name')[1].childNodes[0]
      .nodeValue

    if (this.placeMarksLength > 1) {
      for (let index = 0; index < this.placeMarksLength; index++) {
        this.formatData(
          xmlDoc.getElementsByTagName('coordinates')[index].childNodes[0]
            .nodeValue,
        )

        // this.entityCodeModal = (
        //   xmlDoc.getElementsByTagName('name')[index + 2].childNodes[0]
        //     .nodeValue + kmlPrimeName
        // ).replace(/ /g, '')
        this.entityCodeModal = momentDate().format('YYYYMMDDHHMMSS')
        this.entityNameModal =
          xmlDoc.getElementsByTagName('name')[index + 2].childNodes[0]
            .nodeValue +
          '-' +
          kmlPrimeName

        this.finishEntityEntryDetails.push({
          PRJID: this.prjId,
          OEMID: this.entityTypId ? this.entityTypId : null,
          ENTITYCD: this.entityCodeModal ? this.entityCodeModal : null,
          ENTITYNAME: this.entityNameModal ? this.entityNameModal : null,
          PRNTID: this.ddlParantModal ? this.ddlParantModal : null,
          KML: this.txtAreaKmlModal,
          ISOPERTNL: 1,
          ISACTIVE: 1,
          ENTRYDT: this.currentDate,
          UserId: this.userid,
        })
      }

      console.log(
        'this.finishEntityEntryDetails',
        this.finishEntityEntryDetails,
      )
    } else {
      this.formatData(
        xmlDoc.getElementsByTagName('coordinates')[0].childNodes[0].nodeValue,
      )

      // this.entityCodeModal = xmlDoc
      //   .getElementsByTagName('name')[1]
      //   .childNodes[0].nodeValue.replace(/ /g, '')
      this.entityCodeModal = momentDate().format('YYYYMMDDHHMMSS')
      this.entityNameModal = xmlDoc.getElementsByTagName(
        'name',
      )[1].childNodes[0].nodeValue

      this.finishEntityEntryDetails.push({
        PRJID: this.prjId,
        OEMID: this.entityTypId ? this.entityTypId : null,
        ENTITYCD: this.entityCodeModal ? this.entityCodeModal : null,
        ENTITYNAME: this.entityNameModal ? this.entityNameModal : null,
        PRNTID: this.ddlParantModal ? this.ddlParantModal : null,
        KML: this.txtAreaKmlModal,
        ISOPERTNL: 1,
        ISACTIVE: 1,
        ENTRYDT: this.currentDate,
        UserId: this.userid,
      })

      console.log(
        'this.finishEntityEntryDetails',
        this.finishEntityEntryDetails,
      )
    }
  }

  formatData(kmlCoords) {
    let firstreplace = kmlCoords.replace(/,0/g, ',')

    let secreplace = firstreplace.replace(/,28/g, ' 28')
    //$('#ember1963_new').val('POLYGON((' + secreplace + '))')

    if (this.uploadingKmltype == 'geofence') {
      this.txtAreaKmlModal =
        'POLYGON((' +
        secreplace.replace(/^\s+/g, '').replace(/,\s*$/, '') +
        '))'
    }
    if (this.uploadingKmltype == 'singlePoint') {
      this.txtAreaKmlModal =
        'LINESTRING(' +
        secreplace.replace(/^\s+/g, '').replace(/,\s*$/, '') +
        ')'
    }

    if (this.uploadingKmltype == 'routeOrPath') {
      this.txtAreaKmlModal =
        'POINT(' + secreplace.replace(/^\s+/g, '').replace(/,\s*$/, '') + ')'
    }
  }
  clearEntityData() {
    this.ddlEntityCatModal = null
    this.ddlEntityTypeModal = null
    this.entityCodeModal = null
    this.entityNameModal = null
    this.ddlParantModal = null
    this.txtAreaKmlModal = null
    this.entityEntCodeDiv = false
    this.kmlPlacemark = null
    this.uploadingKmltype = null
    this.finishEntityEntryDetails = []
    this.kmlRawFile = null
    this.entityKmlRawData = null
  }
  //#######################Validations Sections START##########################//
  // To check the Entity Code is Empty or Not
  isEntityCodeEmpty() {
    if (
      this.entityCodeModal == null ||
      this.entityCodeModal == undefined ||
      this.entityCodeModal == ''
    ) {
      this.isSavebtn = true
      this.entityCodeMsg = true
      this.entityEntCodeDiv = false
      return
    } else {
      this.isSavebtn = false
      this.entityCodeMsg = false
    }
    //this.entityCodeModal.replace(/ /g,'');
    this.entityCodeModal = this.entityCodeModal.replace(/ /g, '')
    this.isSavebtn = true
    this.entityEntCodeDiv = true
    this.imagePath = '../../assets/img/loading.gif'
    this.http
      .get(
        environment.apiUrl +
          'admin/getEntityCodeAvailability?ENTITYCD=' +
          this.entityCodeModal,
      )
      .subscribe((data) => {
        var isCodeAvaible = data
        if (isCodeAvaible[0].result == 'Available') {
          this.isSavebtn = false
          this.entityCodeMsg = true
          this.entityCodeMsg = false
          this.imagePath = '../../assets/img/ok.png'
        }
        if (isCodeAvaible[0].result == 'All ready exist') {
          this.isSavebtn = true
          this.entityCodeMsg = true
          this.imagePath = '../../assets/img/wrong.jpg'
          this.entityCodeMsg = false
        }
      })
  }
  //To check The Entity Name is Empty or Not
  isEntityNameEmpty() {
    if (
      this.entityNameModal == null ||
      this.entityNameModal == undefined ||
      this.entityNameModal == ''
    ) {
      this.isSavebtn = true
      this.entityNameAlertMsg = true
      return
    } else {
      this.isSavebtn = false
      this.entityNameAlertMsg = false
    }
  }
  onChangeSelectParantName(id) {
    // if (this.ddlParantModal == null || this.ddlParantModal == undefined || this.ddlParantModal == '') {
    //   this.isSavebtn = true;
    //   this.entityPrntNameMsg = true;
    //   return;
    // } else {
    //   this.isSavebtn = false;
    //   this.entityPrntNameMsg = false;
    // }
    console.log(id)
  }

  /*
   * get Vehicle Status
   */
  setStatus(data) {
    if (data.ActiveStatus == 'Unassigned') {
      this.assignStatus = 'Assign'
    } else {
      this.assignStatus = 'Unassigned'
    }
  }

  /*
   * set/Assign Vehicle to the Entity
   */
  setAssignStatus(data) {
    var status = data.ActiveStatus
    if (status == 'Unassigned') {
      this.changeStatus = 1
      this.titleData = 'Are you sure to Assign this Vehicle ?'
      this.successMsg = 'User Assign successfully.'
    } else {
      this.changeStatus = 0
      this.titleData = 'Are you sure to Unassign this Vehicle ?'
      this.successMsg = 'Vehicle Unassign successfully.'
    }
    var assignData = {
      VEHID: data.vehID,
      ENTITYID: this.entityId,
      ISACTIVE: this.changeStatus,
      userId: this.userid,
    }
    Swal({
      title: this.titleData,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Convert it!',
    }).then((result) => {
      if (result.value) {
        this.http
          .post(
            environment.apiUrl + 'admin/editAssignDetailByProject',
            assignData,
          )
          .subscribe((data) => {
            var response = data
            var resCode = response[0].RESPONSECODE
            //var respMsg=response[1].RESPONSEMESSAGE
            if (resCode == '200') {
              this.getVehAssignmentbyEntityId()
              this.getAssignedVehicleList(this.entityId)
              Swal(this.successMsg, 'success')
            } else {
              Swal(this.successMsg, 'error')
            }
          })
      }
    })
  }

  /*
   * Get staff details for assign and unassign
   */
  getStaffStatus(data) {
    // console.log("Emp List11",data.AssignStatus)
    if (data.AssignStatus == 'Assigned') {
      this.staffAssignstatus = 'Unassigned'
    } else {
      this.staffAssignstatus = 'Assigned'
    }
  }

  /*
   * Assign Vehicle to the Entity
   */
  setStaffAssignStatus(data) {
    // console.log("emp selected data",data)
    var status = data.AssignStatus
    if (status == 'Unassigned') {
      this.changeStatus = 1
      this.titleData =
        'Are you sure to Assign this Employee to selected Location?'
      this.empassignMsg = 'Employee Assign successfully.'
    } else {
      this.changeStatus = 0
      this.titleData =
        'Are you sure to Unassign this Employee from this Location?'
      this.empassignMsg = 'Employee Unassign successfully.'
    }
    var empAssign = {
      EMPID: data.empID,
      ENTITYID: this.entityId,
      ROLEID: data.roleID,
      ISACTIVE: this.changeStatus,
      userId: this.userid,
    }
    Swal({
      title: this.titleData,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Convert it!',
    }).then((result) => {
      if (result.value) {
        this.http
          .post(
            environment.apiUrl + 'admin/editAssignEmployeeDetailByProject',
            empAssign,
          )
          .subscribe((data) => {
            var response = data
            var resCode = response[0].RESPONSECODE
            if (resCode == '200') {
              this.getStaffAssignmentbyEntityId()
              this.getAssignedStaffList(this.entityId)
              Swal(this.empassignMsg, 'success')
            } else {
              Swal(this.empassignMsg, 'error')
            }
          })
      }
    })
  }

  /*
   * Get vehicle assined Details
   */
  getAssignedVehicleList(entityId) {
    this.http
      .get(
        environment.apiUrl +
          'admin/getAssinedVehList?PRJID=' +
          this.prjId +
          '&ENTITYID=' +
          entityId,
      )
      .subscribe((data) => {
        this.vehicleAssignedList = data
        if (this.vehicleAssignedList == 0) {
          this.vehAssignNotFound = true
          this.vehAssinedCount = 0
        } else {
          this.vehAssinedCount = this.vehicleAssignedList.length
          this.vehAssignNotFound = false
        }
      })
  }

  /*
   * Get Staff assined Details
   */
  getAssignedStaffList(entityId) {
    this.http
      .get(
        environment.apiUrl +
          'admin/getAssinedStaffList?PRJID=' +
          this.prjId +
          '&ENTITYID=' +
          entityId,
      )
      .subscribe((data) => {
        this.staffAssignedList = data
        if (this.staffAssignedList == 0) {
          this.staffAssignNotFound = true
          this.empAssignCount = 0
        } else {
          this.empAssignCount = this.staffAssignedList.length
          this.staffAssignNotFound = false
        }
      })
  }

  currEntityId: any
  map: any
  viewRouteOnMap(data) {
    $('#entityMapRouteModal').modal('show')
    //this.googleMap(28.459497,77.026634);
    // console.log("entityId",data)
    this.currEntityId = data.ID
    this.getMapRoute(this.currEntityId)
  }

  update(data) {
    this.clearData()
    this.currEntityId = data.ID
    // this.getMapRoute(this.currEntityId);
    // this.entityAssignTypeData.push(data)
    // this.entityAssignTypeData = this.entityAssignTypeData.filter(e => {
    //   e.ID == data.OEMTYPID
    // });
    // this.entityTypData = this.entityTypData.filter(e => {
    //   e.ID == data.OEMTYPID
    // });

    // this.ddlEntityCatModal = this.entityAssignTypeData[0].OEMTYPID
    // this.ddlEntityTypeModal = data.entitytypeID
    // this.ddlParantModal = data.PRNTNAME ? data.PRNTNAME : null
    // this.entityNameModal = data.ENTITYNAME
    this.entityCodeModal = data.ENTITYCD
    // this.entityIsActiveModel = data.ISACTIVE
    // $("#addNewEntityModal").modal("show");
    $('#updateKMLModal').modal('show')
  }

  //updateEntityNameModal

  openNewEntityName(data) {
    this.clearData()
    this.currEntityId = data.ID
    this.entityCodeModal = data.ENTITYCD
    $('#updateEntityNameModal').modal('show')
  }

  /*
   * this method is used to save the Entity Details into the entitymst table
   */
  updateKML() {
    this.currentDate = new Date()
    if (
      this.KMLModal == null ||
      this.KMLModal == undefined ||
      this.KMLModal == ''
    ) {
      this.isSavebtn = true
      this.entityNameMsg = true
      return
    }

    var entityMstrJsonData = {
      PRJID: this.prjId,
      ENTITYCD: this.entityCodeModal ? this.entityCodeModal : null,
      ID: this.currEntityId ? this.currEntityId : null,
      KML: 'POLYGON((' + this.KMLModal + '))',
      UserId: this.userid,
    }

    this.http
      .post(environment.apiUrl + 'admin/updateKML', entityMstrJsonData)
      .subscribe((data) => {
        var res: any = data
        this.entitySaveSuccessMsg = res.status == 'ok' ? true : false
        this.entitySaveWarningMsg = res.status == 'ok' ? false : true
      })
    this.isSavebtn = true
    this.getEntityTypeByProject()
    setTimeout(() => {
      $('#updateKMLModal').modal('hide')
    }, 2000)
  }

  updateEntityNameBtn() {
    this.currentDate = new Date()
    if (
      this.entityNewName == null ||
      this.entityNewName == undefined ||
      this.entityNewName == ''
    ) {
      this.isSavebtn = true
      this.entityNameSaveWarningMsg = true
      return
    }

    var entityMstrJsonData = {
      PRJID: this.prjId,
      ENTITYCD: this.entityCodeModal ? this.entityCodeModal : null,
      ID: this.currEntityId ? this.currEntityId : null,
      ENTITYNAME: this.entityNewName,
      UserId: this.userid,
    }

    this.http
      .post(environment.apiUrl + 'admin/updateEntityName', entityMstrJsonData)
      .subscribe((data) => {
        var res: any = data
        this.entityNameSaveSuccessMsg = res.status == 'ok' ? true : false
        this.entityNameSaveWarningMsg = res.status == 'ok' ? false : true
      })
    this.isSavebtn = true
    this.getEntityTypeByProject()
    setTimeout(() => {
      $('#updateEntityNameModal').modal('hide')
    }, 2000)
  }

  clearData() {
    // this.entityAssignTypeData = []
    this.isSavebtn = false
    this.entitySaveSuccessMsg = false
    this.entitySaveWarningMsg = false
    this.entityCodeModal = null
    this.currEntityId = null
    this.KMLModal = null
    this.entityNewName = null
  }

  // /*
  // * Get LAT LNg by Address
  // */
  // googleMap(lat, lng){
  //       var myLatLng = {lat:lat, lng: lng};
  //       var map = new google.maps.Map(document.getElementById('googleMap'), {
  //       zoom: 17,
  //       center: myLatLng
  //       });
  //       var marker = new google.maps.Marker({
  //       position: myLatLng,
  //       map: map,
  //       title: 'Hello World!'
  //     });
  // }

  getMapRoute(entityId) {
    this.clearFeature()
    this.http
      .get(environment.apiUrl + 'admin/entityRoute?' + 'vehId=' + entityId)
      .subscribe((data) => {
        // console.log("Newdata.....",data)
        var result: any
        result = data
        this.map.data.addGeoJson(result.geoJson)
        this.zoom(this.map, true)
        this.setStyle(this)
      })
  }

  clearFeature() {
    this.map.data.forEach((feature) => {
      this.map.data.remove(feature)
    })
  }

  zoom(this, map, isZone) {
    this.bounds = new google.maps.LatLngBounds()
    this.map.data.forEach((feature) => {
      if (isZone) {
        this.processPoints(
          feature.getGeometry(),
          this.bounds.extend,
          this.bounds,
        )
      } else {
        if (feature.getProperty('type') == 'route') {
          this.processPoints(
            feature.getGeometry(),
            this.bounds.extend,
            this.bounds,
          )
        }
      }
    })
    map.fitBounds(this.bounds)
  }
  setStyle(thisRef) {
    thisRef.map.data.setStyle(function (feature) {
      var color = feature.getProperty('FillColor')
      var strokeColor = feature.getProperty('Bcolor')
      if (feature.getProperty('TYPE') == 'stopMarker') {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 2,
          fillOpacity: 0.05,
          icon: 'assets/img/stopMarker.png',
          strokeopacity: 0.2,
          label: {
            text: feature.getProperty('number'),
            color: '#FFFFFF',
            fontSize: '13px',
            background: 'yellow',
            fontWeight: 'bold',
            AlignmentVertical: 'top',
            AlignmentHorizontal: 'center',
          },
          labelClass: 'my-custom-class-for-label',
        }
      } else if (feature.getProperty('TYPE') == 'khatta') {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 5,
          fillOpacity: 0.0,
          strokeopacity: 0.2,
          icon: 'assets/img/khatta.png',
        }
      } else if (
        feature.getProperty('Oemid') == 8 ||
        feature.getProperty('Oemid') == 9 ||
        feature.getProperty('Oemid') == 10
      ) {
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 3,
          fillOpacity: 0.1,
          strokeopacity: 0.8,
        }
      } else {
        return {
          fillColor: color,
          strokeColor: '#040C0A',
          strokeWeight: 4,
          fillOpacity: 0.1,
          strokeopacity: 0.4,
        }
      }
    })
  }

  ngOnInit(): void {
    this.prjId = this.auth.getAuthentication().projectId
    this.userid = this.auth.getAuthentication().id
    this.getEntityTypeByProject()
    this.getZonesAndWards()
    this.BindEntityStatus()

    // this.entityIsActiveModel = this.EntityStatusData[0].ID;
    // this.ddlEntityModal = this.entityTypeData[0].ID;
    // this.getEntityDetails(1)
    // this.getEntitysummary();
  }

  ActiveInActive(data) {
    console.log(data)

    if (data.ISACTIVE == 'Active') {
      this.entityUpdateId = data.ID
      this.entityUpdateValue = 0
    } else {
      this.entityUpdateId = data.ID
      this.entityUpdateValue = 1
    }

    var updateEntitydata = {
      Id: this.entityUpdateId,
      values: this.entityUpdateValue,
    }

    console.log('295', updateEntitydata)

    this.http
      .post(
        environment.apiUrl + 'admin/updateEntityActiveStatus',
        updateEntitydata,
      )
      .subscribe((data) => {
        this.getEntityTypeByProject()

        //this.syncData();
        Swal('Quantity has been updated successfully.', 'success')
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/entity/entityMngt/entity.component.ts